import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    popup_visibility: false
  },
  actions: actions,
  mutations: mutations,
  getters: getters
}
